<div class="row">
  @if (config) {
  <qa-grid-data [config]="config"></qa-grid-data>
  }
</div>
